import {NgModule} from '@angular/core';
import {CustomerService} from './customer.service';
import {CustomerOverviewComponent} from './customer-overview.component';
import {CustomerFormComponent} from './customer-form.component';
import {ContactModule} from '../contact/contact.module';
import {SharedModule} from '../shared/shared.module';
import {CustomerDatatableComponent} from './customer-datatable.component';
import {CustomerContactFormComponent} from './customer-contact-form.component';

@NgModule({
  declarations: [
    CustomerOverviewComponent,
    CustomerDatatableComponent,
    CustomerFormComponent,
    CustomerContactFormComponent
  ],
  exports: [
    CustomerOverviewComponent,
    CustomerDatatableComponent,
    CustomerFormComponent
  ],
  imports: [
    SharedModule,
    ContactModule
  ],
  providers: [
    CustomerService
  ]
})
export class CustomerModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/customer/customer.module.ts